import { supabase } from '@/services/supabaseClient';

/**
 * Wrapper autour de fetch() qui ajoute automatiquement le token JWT Supabase
 * dans le header Authorization: Bearer <token>.
 *
 * Utilisation identique à fetch() standard :
 *   const res = await authenticatedFetch('/api/purchase-invoices/sync', { method: 'POST' });
 */
export async function authenticatedFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const headers = new Headers(init?.headers);

  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`);
  }

  if (!headers.has('Content-Type') && init?.body && typeof init.body === 'string') {
    headers.set('Content-Type', 'application/json');
  }

  return fetch(input, { ...init, headers });
}
